import { detalheExtrato } from '@/views/31/RegrasDeNegocio31'
import moment from 'moment/moment'

const preloadWidget = async (row, funcionalidade, authorization) => {
  const detalhe = await detalheExtrato(row.guia.idAutorizacao)
  return createPayload(detalhe, funcionalidade, authorization)
}

const parseDate = (value) => {
  if (!value) {
    return '-'
  }
  if ((/\d{4}-\d{2}-\d{2}/).test(value)) {
    return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }
  try {
    return moment(Number.parseInt(value)).format('DD/MM/YYYY')
  } catch (ignored) {
    return moment(value).format('DD/MM/YYYY')
  }
}

function createPayload (detalhe, funcionalidade, authorization) {
  const payload = {
    'idFuncionalidade': funcionalidade.idFuncionalidade,
    'data': {},
    'configuracao': {
      'parametros': {},
      'metodoEnvio': []
    },
    'opcoesDeEnvio': []
  }
  const { configuracoesDeWidgets } = funcionalidade.parametros

  if (configuracoesDeWidgets.permiteEnvioChatWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 1,
        'descricao': 'Mensagem no chat'
      },
      'sincrono': true
    })
  }
  if (configuracoesDeWidgets.permiteEnvioEmailWidget && configuracoesDeWidgets.templateEnvioEmailWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 2,
        'descricao': 'E-mail'
      },
      'template': configuracoesDeWidgets.templateEnvioEmailWidget,
      'sincrono': true
    })
  }
  if (configuracoesDeWidgets.permiteEnvioWhatsappWidget && configuracoesDeWidgets.templateEnvioWhatsappWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 3,
        'descricao': 'WhatsApp'
      },
      'template': configuracoesDeWidgets.templateEnvioWhatsappWidget,
      'sincrono': true
    })
  }
  payload.opcoesDeEnvio.push({
    'nome': 'Extrato de Autorização',
    'nomeIntegracao': 'detalheExtrato',
    'integracao': {
      'headers': {
        'Authorization': authorization
      },
      'parametros': {},
      'rota': {
        ...funcionalidade.rotas.detalhe
      },
      'payload': {
      }
    },
    'data': {
      'textoWidget': `Solicitacao criada em: ${(detalhe.guia) ? parseDate(detalhe.guia.dataSolicitacao) : parseDate(detalhe.data_registro)}, sob o numero de protocolo: ${(detalhe.guia.numeroProtocolo) ? detalhe.guia.numeroProtocolo : detalhe.protocolo} com status de "${(detalhe.situacao) ? detalhe.situacao.descricao : detalhe.status_label}"`,
      ...detalhe,
      ...detalhe.guia
    }
  })
  return payload
}
export { preloadWidget }
